import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function FlamingoLiteracyLogo(props) {
  return (
    <SvgIcon viewBox="0 0 250 91" {...props}>
      <path
        d="M45.0077 87.8525L35.8262 88.2755V45.6153L34.4434 47.0148V68.1693V90.3755H47.6326L45.0077 87.8525Z"
        fill="#CAA965"
      />
      <path
        d="M37.6759 43.739L34.4433 47.0078L30.5762 42.8419L37.6759 43.739Z"
        fill="#F79979"
      />
      <path
        d="M30.8768 45.4865L8.93595 41.6007L29.7709 43.9703L30.6829 42.9698L6.64097 40.1662L5.87012 42.3546L30.7122 46.7229L29.203 58.0439L32.0569 55.7143L32.6711 47.5263L30.8768 45.4865Z"
        fill="#CAA965"
      />
      <path
        d="M5.36776 34.0705L0 39.3423L15.6728 37.6951L5.36776 34.0705Z"
        fill="#F79979"
      />
      <path
        d="M22.2225 36.2021L11.1978 27.2631L5.36816 34.0708L22.2225 36.2021Z"
        fill="#F57859"
      />
      <path
        d="M22.2993 36.202L15.6732 37.6953L5.36816 34.0707L22.2993 36.202Z"
        fill="#F04338"
      />
      <path
        d="M49.2936 27.2627L37.5625 17.5531L39.3184 25.8146L49.2936 27.2627Z"
        fill="#F79979"
      />
      <path
        d="M39.3177 25.8149L37.5618 17.5534L24.4307 16.1748L39.3177 25.8149Z"
        fill="#F57859"
      />
      <path
        d="M46.6652 36.8677L29.79 24.436L49.2936 27.2627L46.6652 36.8677Z"
        fill="#F57859"
      />
      <path
        d="M23.8397 30.8969L29.111 36.3989L22.2217 36.2017L23.8397 30.8969Z"
        fill="#F79979"
      />
      <path
        d="M29.7895 24.4361L23.84 30.897L11.1973 27.2628L29.7895 24.4361Z"
        fill="#F04338"
      />
      <path
        d="M46.6643 36.8679L37.5616 43.7642L22.2217 36.202L46.6643 36.8679Z"
        fill="#F04338"
      />
      <path
        d="M39.318 25.8149L24.4309 16.1748L14.0752 22.3006L39.318 25.8149Z"
        fill="#EE3124"
      />
      <path
        d="M37.5616 43.7642L19.7051 41.6961L22.2217 36.202L37.5616 43.7642Z"
        fill="#EE3124"
      />
      <path
        d="M23.8398 30.8969L29.7893 24.436L46.6645 36.8677L23.8398 30.8969Z"
        fill="#EE3124"
      />
      <path
        d="M23.84 30.8973L22.222 36.2021L11.1973 27.2631L23.84 30.8973Z"
        fill="#EE3124"
      />
      <path
        d="M46.6645 36.8677L29.1111 36.3989L23.8398 30.8969L46.6645 36.8677Z"
        fill="#F57859"
      />
      <path
        d="M46.6652 36.8679L37.5625 43.7642L45.2578 42.0125L46.6652 36.8679Z"
        fill="#C52C23"
      />
      <path
        d="M29.7895 24.436L11.1973 27.2627L14.075 22.3003L29.7895 24.436Z"
        fill="#C52C23"
      />
      <path
        d="M22.2221 36.2022L19.7056 41.6963L15.6729 37.6955L22.2221 36.2022Z"
        fill="#C52C23"
      />
      <path
        d="M52.7051 21.9982L55.3149 33.959L59.0025 21.6541L52.7051 21.9982Z"
        fill="#F79979"
      />
      <path
        d="M56.5459 5.70996L54.6729 0.904817L61.6782 0.000222206L56.5459 5.70996Z"
        fill="#F57859"
      />
      <path
        d="M55.1141 8.66649L59.0025 21.6545L52.7051 21.9985L55.1141 8.66649Z"
        fill="#F57859"
      />
      <path
        d="M55.3151 33.9594L45.2578 42.0127L49.2937 27.2631L55.3151 33.9594Z"
        fill="#F04338"
      />
      <path
        d="M56.5454 5.70953L52.055 14.979L50.7393 7.15759L56.5454 5.70953Z"
        fill="#F04338"
      />
      <path
        d="M55.1141 8.66649L52.7051 21.9985L52.0557 14.9793L55.1141 8.66649Z"
        fill="#C52C23"
      />
      <path
        d="M54.6724 0.904512L50.7393 7.15771L56.5454 5.70966L54.6724 0.904512Z"
        fill="#EE3124"
      />
      <path
        d="M52.7046 21.9982L49.293 27.2627L55.3145 33.959L52.7046 21.9982Z"
        fill="#EE3124"
      />
      <path
        d="M67.5957 9.92383L66.819 2.96487L61.6777 0.00014782L67.5957 9.92383Z"
        fill="#F04338"
      />
      <path
        d="M62.1497 11.0503L56.5459 5.70959L61.6782 -0.000145912L62.0527 8.28645L62.1497 11.0503Z"
        fill="#F04338"
      />
      <path
        d="M62.0522 8.28674L67.5957 9.92383L61.6777 0.00014782L62.0522 8.28674Z"
        fill="#FEF2D6"
      />
      <path
        d="M68.8572 19.2349L67.5962 9.92393L62.0527 8.28684L68.8572 19.2349Z"
        fill="#F0DFAB"
      />
      <path
        d="M62.3638 25.6763L66.1984 14.9791L62.0527 8.28643L62.3638 25.6763Z"
        fill="#CAA965"
      />
      <path
        d="M68.8566 19.2345L62.3633 25.6763L66.1978 14.9791L68.8566 19.2345Z"
        fill="#282A45"
      />
      <path
        d="M63.1121 5.73819C62.8233 6.0269 62.8233 6.49454 63.1121 6.78339C63.4003 7.07155 63.8685 7.07155 64.1568 6.78339C64.445 6.49454 64.445 6.0269 64.1568 5.73819C63.8685 5.44988 63.4003 5.44988 63.1121 5.73819Z"
        fill="#282A45"
      />
      <path
        d="M82.9053 22.1811H97.5707V23.9844H84.8817V32.5474H97.3273V34.3497H84.8817V45.3052H82.9053V22.1811Z"
        fill="#282A45"
      />
      <path
        d="M102.393 22.1811H104.369V43.5029H115.567V45.3052H102.393V22.1811Z"
        fill="#282A45"
      />
      <path
        d="M124.064 37.8167H135.123L129.576 24.1228L124.064 37.8167ZM135.747 39.6198H123.44L121.117 45.3052H118.898L128.363 22.1811H130.824L140.289 45.3052H138.07L135.747 39.6198Z"
        fill="#282A45"
      />
      <path
        d="M163.314 24.7814L154.888 45.3052H154.126L145.667 24.7814V45.3052H143.69V22.1811H146.638L154.507 41.3528L162.343 22.1811H165.324V45.3052H163.314V24.7814Z"
        fill="#282A45"
      />
      <path
        d="M171.083 22.1811H173.059V45.3052H171.083V22.1811Z"
        fill="#282A45"
      />
      <path
        d="M180.792 25.3359V45.3052H178.815V22.1811H180.826L195.317 41.8734V22.1811H197.293V45.3052H195.353L180.792 25.3359Z"
        fill="#282A45"
      />
      <path
        d="M213.904 21.8002C217.719 21.8002 220.491 23.3249 222.606 25.7521L221.116 26.8271C219.486 24.8852 216.851 23.603 213.904 23.603C208.461 23.603 204.266 27.7279 204.266 33.7605C204.266 39.7239 208.461 43.9538 213.904 43.9538C216.989 43.9538 219.417 42.428 220.7 41.1446V35.5979H211.962V33.8297H222.676V41.9081C220.63 44.1961 217.544 45.7559 213.904 45.7559C207.421 45.7559 202.187 40.9023 202.187 33.7605C202.187 26.6188 207.421 21.8002 213.904 21.8002Z"
        fill="#282A45"
      />
      <path
        d="M238.766 23.603C233.15 23.603 229.614 27.867 229.614 33.7604C229.614 39.5853 233.15 43.9191 238.766 43.9191C244.313 43.9191 247.92 39.5853 247.92 33.7604C247.92 27.867 244.313 23.603 238.766 23.603ZM238.766 21.8002C245.528 21.8002 250 27.0002 250 33.7604C250 40.5208 245.528 45.7212 238.766 45.7212C231.971 45.7212 227.534 40.5208 227.534 33.7604C227.534 27.0002 231.971 21.8002 238.766 21.8002Z"
        fill="#282A45"
      />
      <path
        d="M82.9111 52.6352H86.3781V72.7083H96.8829V75.7593H82.9111V52.6352Z"
        fill="#EE3124"
      />
      <path
        d="M100.699 52.6352H104.166V75.7593H100.699V52.6352Z"
        fill="#EE3124"
      />
      <path
        d="M114.984 55.6862H107.808V52.6352H125.593V55.6862H118.451V75.7593H114.984V55.6862Z"
        fill="#EE3124"
      />
      <path
        d="M129.202 52.6352H144.734V55.6862H132.669V62.4464H144.491V65.4979H132.669V72.7083H144.734V75.7593H129.202V52.6352Z"
        fill="#EE3124"
      />
      <path
        d="M157.667 55.6862H151.843V63.7985H157.667C160.163 63.7985 161.966 62.17 161.966 59.7423C161.966 57.3157 160.163 55.6862 157.667 55.6862ZM156.177 66.8494H151.843V75.7593H148.376V52.6352H158.117C162.521 52.6352 165.538 55.4779 165.538 59.7423C165.538 63.9029 162.728 66.1217 159.783 66.5026L165.711 75.7593H161.689L156.177 66.8494Z"
        fill="#EE3124"
      />
      <path
        d="M174.105 67.8898H183.431L178.75 55.6521L174.105 67.8898ZM184.436 70.9748H173.1L171.228 75.7593H167.413L176.601 52.6352H180.935L190.121 75.7593H186.308L184.436 70.9748Z"
        fill="#EE3124"
      />
      <path
        d="M190.68 64.2145C190.68 57.1074 195.949 52.2543 202.536 52.2543C207.078 52.2543 209.921 54.4383 211.724 57.142L208.777 58.7023C207.563 56.7611 205.276 55.3393 202.536 55.3393C197.857 55.3393 194.251 59.0145 194.251 64.2145C194.251 69.3803 197.857 73.0897 202.536 73.0897C205.276 73.0897 207.563 71.6689 208.777 69.7271L211.724 71.2869C209.886 73.9916 207.078 76.1758 202.536 76.1758C195.949 76.1758 190.68 71.3215 190.68 64.2145Z"
        fill="#EE3124"
      />
      <path
        d="M221.921 66.0872L212.872 52.6352H216.86L223.654 62.967L230.38 52.6352H234.402L225.387 66.0872V75.7593H221.921V66.0872Z"
        fill="#EE3124"
      />
    </SvgIcon>
  );
}
